import { command } from 'ccstate'
import { searchQuery$ } from '../state/searchState'

export const updateSearchQuery$ = command(({ set }, query: string) => {
  set(searchQuery$, query)
})

export const clearSearchQuery$ = command(({ set }) => {
  set(searchQuery$, '')
})
